
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { resetBoundariesState } from "../boundaries/boundariesSlice";

const initialState = {
  
  isLoadingGetAllUsersLocation: false,
  allUsersLocationList: [],

  filteredUsersLocation: [],

  hoveredMarker: null,

  filterDurationHour: 480,
  filterDurationDay: 20,
  
  constantFilterDurationHour: 480,
  constantFilterDurationDay: 20,


  filterDurationType: 2,
  
  filterPhoneNumber: "",

  filteredUser: null,

}

export const getAllUsersLocation = createAsyncThunk("boundaries/getAllUsersLocation", async({duration, phoneNumber, userName}, thunkApi)=> {
    try {

        

        const {data} = await axiosInstance.get(`/User/GetAllUsersLocation?duration=${duration}`)

        thunkApi.dispatch(resetBoundariesState())
        
        return data
    } catch (error) {
        console.log(error);
        return thunkApi.rejectWithValue(error)
    }
})


const locsSlice = createSlice({
    name: "locs",
    initialState,
    reducers: {
        setIsLoadingGetAllUsersLocation: (state,action) => {
            state.isLoadingGetAllUsersLocation = action.payload
        },

        setFilteredUsersLocations: (state,action) => {

            const {data, type, insideUsersIds} = action.payload

            if(type === "reset1"){
                state.filteredUsersLocation = state.allUsersLocationList
            }

            else if(type === "reset2"){
                state.filteredUsersLocation = state.allUsersLocationList.filter(userItem => insideUsersIds.includes(userItem.id))
            }
            else{
                state.filteredUsersLocation = data
            }
        },
        
        setHoveredMarker: (state, action) => {
            state.hoveredMarker = action.payload
        },

        updateFilterDuration: (state,action) => {

            const {type, data} = action.payload

            if(type === 1){
                state.filterDurationHour = data
                state.constantFilterDurationHour = data
            }
            else{
                state.filterDurationDay = data
                state.constantFilterDurationDay = data
            }
        },


        updateFilterDurationType: (state,action) => {
            state.filterDurationType = action.payload
            state.filterDurationHour = ""
            state.filterDurationDay = ""
        },

        updateFilterPhoneNumber: (state,action) => {
            state.filterPhoneNumber = action.payload
        },

        setFilteredUser: (state,action) => {
            state.filteredUser = action.payload
        }

    },
    extraReducers:(builder)=> {
        builder

        //! getAllUsersLocation
        .addCase(getAllUsersLocation.pending, (state)=> {
            state.isLoadingGetAllUsersLocation = true
        })

        .addCase(getAllUsersLocation.fulfilled, (state, action)=> {
            state.isLoadingGetAllUsersLocation = false
            state.allUsersLocationList = action.payload.data.$values
            state.filteredUsersLocation = action.payload.data.$values
            state.filterPhoneNumber = ""
            state.filteredUser = null
        })

        .addCase(getAllUsersLocation.rejected, (state, action)=> {
            state.isLoadingGetAllUsersLocation = false
        })
    }
})


export const {
    setIsLoadingGetAllUsersLocation,
    setFilteredUsersLocations,
    setHoveredMarker,
    updateFilterDuration,
    updateFilterDurationType,
    updateFilterPhoneNumber,
    setFilteredUser
} = locsSlice.actions
export default locsSlice.reducer